import React from "react";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";

interface Props {
    onCreateNew: () => void;
    onCreateFromInvoice: () => void;
    align?: "start" | "center" | "end";
}

export const CreateInvoiceTemplateMenu: React.FC<Props> = ({
    onCreateNew,
    onCreateFromInvoice,
    align = "end",
}) => (
    <Menu.Root
        align={align}
        trigger={
            <Button type="button" variant="primary" size="md">
                Create template
            </Button>
        }
    >
        <Menu.Item onClick={onCreateNew}>New</Menu.Item>
        <Menu.Item onClick={onCreateFromInvoice}>From invoice</Menu.Item>
    </Menu.Root>
);
